import { Box, Heading, HStack } from "@chakra-ui/react";
import { ReactNode } from "react";

const WidgetPanel = ({
  title,
  addOn,
  children,
}: {
  title?: string;
  addOn?: ReactNode;
  children: ReactNode;
}) => {
  return (
    <Box p="20px" w="100%" borderRadius="4px" border="1px solid #E4E4E4">
      {title && (
        <HStack justifyContent="space-between" alignItems="center" mb="24px">
          <Heading as="h5" fontSize="16px" fontWeight="500" m="0px">
            {title}
          </Heading>
          {addOn}
        </HStack>
      )}
      {children}
    </Box>
  );
};

export default WidgetPanel;
